export const UserType = Object.freeze({
	CUSTOMER: "customer",
	AGENT: "agent",
});
